module.exports = function() {
  return new Worker(__webpack_public_path__ + "fb086a0ee689fdee0e40.worker.js");
};